import * as React from 'react'
import { SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const MedalIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="m8.02 11.417.75-2.396-1.978-1.542h2.416L10 5l.77 2.48h2.438L11.23 9.02l.73 2.397L10 9.937l-1.98 1.48Zm-2.937 7.75v-6.334c-.625-.652-1.073-1.368-1.343-2.145a7.116 7.116 0 0 1-.407-2.355c0-1.888.64-3.472 1.917-4.75C6.528 2.306 8.111 1.667 10 1.667c1.889 0 3.472.639 4.75 1.916 1.278 1.278 1.917 2.862 1.917 4.75 0 .792-.136 1.577-.407 2.355-.27.777-.718 1.493-1.343 2.145v6.334L10 17.52l-4.917 1.646ZM10 13.75c1.514 0 2.795-.524 3.844-1.573 1.048-1.048 1.573-2.33 1.573-3.844 0-1.513-.525-2.795-1.573-3.843C12.795 3.44 11.514 2.917 10 2.917c-1.514 0-2.795.524-3.844 1.573-1.048 1.048-1.573 2.33-1.573 3.843 0 1.514.525 2.796 1.573 3.844C7.205 13.226 8.486 13.75 10 13.75Zm-3.667 3.667L10 16.27l3.667 1.146v-3.563a5.652 5.652 0 0 1-1.792.875c-.639.18-1.264.271-1.875.271s-1.236-.09-1.875-.27a5.652 5.652 0 0 1-1.792-.876v3.563Z"
      fill="#777877"
    />
  </svg>
)

export default MedalIcon
